module.exports = __webpack_public_path__ + "img/earth.4774937d.gif";